export const cronJobs = [
  {
    id: 'LTvItnUBNOatnfOa6gcq',
    current_status: 'failure',
    last_run_date: 1632193373100,
    log_level: 'info',
    command_name: 'FoodReminder',
    ended_at: 1632193405165,
  },
  {
    id: 'MDvItnUBNOatnfOa6gc6',
    current_status: 'success',
    last_run_date: 1631872971089,
    log_level: 'info',
    command_name: 'QuestionnaireReminders',
    ended_at: 1632132178105,
  },
  {
    id: 'Izs6t3UBNOatnfOafAkp',
    current_status: 'in_progress',
    last_run_date: 1632196972192,
    log_level: 'info',
    command_name: 'CompleteGoalReminders',
    ended_at: 1631332973060,
  },
];
export const restartJob = {
  command: 'QuestionnaireReminders',
  createdBy: 1,
  updatedBy: 1,
};
export const singleCronJob = [
  {
    id: 'LTvItnUBNOatnfOa6gcq',
    command_name: 'FoodReminder',
    description: 'Food reminders: [object Object]',
    process_id: 101038,
    status: 'success',
    run_date: 1632193405070,
    log_level: 'info',
    createdBy: 'job',
  },
  {
    id: 'MDvItnUBNOatnfOa6gc6',
    command_name: 'FoodReminder',
    description: 'Error on executing food reminder command: SequelizeUniqueConstraintError: Validation error',
    process_id: null,
    status: 'failure',
    run_date: 1632063809104,
    log_level: 'error',
    createdBy: 'job',
  },
  {
    id: 'Izs6t3UBNOatnfOafAkp',
    command_name: 'FoodReminder',
    description: 'No Food reminders: ',
    process_id: 37135,
    status: 'in_progress',
    run_date: 1631977372293,
    log_level: 'info',
    createdBy: 'job',
  },
];
